<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #101010;
}

.el-message {
  z-index: 9999999 !important;
}
:root {
  --maskDisplay1: none;
  --maskDisplay2: none;
}
</style>
